import {
  DataSourceSelectionListQueryVariables,
  useDataSourceSelectionListQuery,
} from '@kinetic-ui/data-layer';

const selectionListBatch = {
  batchMax: 5,
  batchInterval: 150,
  batchKey: 'dataSourceSelectionListBatch',
};
export const useDataSourceSelectionList = (formId?: string | null) => {
  const variables: DataSourceSelectionListQueryVariables = { query: { formId, limit: 10_000 } };
  return useDataSourceSelectionListQuery({
    skip: !formId,
    variables,
    context: { batch: selectionListBatch },
  });
};
